
import { useEffect, useState } from 'react';
import Navbar from '../Components/NavBarV2';
import Lateral1 from '../images/lateral1.png';
import Lateral2 from '../images/lateral2.png';
import videoFondo from '../images/videoFondo.mp4';
import { db, storage } from '../Firebase/Firebase';
import { getAuth, createUserWithEmailAndPassword, sendEmailVerification, signOut, signInWithEmailAndPassword } from "firebase/auth";
import appFirebase from "../Firebase/Firebase";
import { getFirestore, getDoc, getDocs, collection, addDoc, setDoc, doc, query, where, updateDoc, deleteDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL, deleteObject, listAll } from "firebase/storage";
import Modal from 'react-modal';
import './verificarCoinsComprados.css'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const VerificarCoins = () => {

    const auth = getAuth(appFirebase);
    const [usuarios, setUsuarios] = useState([]);
    const [selectedUsuario, setSelectedUsuario] = useState(null);
    const [modalIsOpenUpdate, setModalIsOpenUpdate] = useState(false);
    const [modalIsOpenDelete, setModalIsOpenDelete] = useState(false);
    const [compras, setCompras] = useState([]);
    const [search, setSearch] = useState('');
    const [filteredCompras, setFilteredCompras] = useState([]);
    // Función para obtener usuarios según el rol del usuario autenticado
    const users = async () => {
        try {
            // Obtener el usuario autenticado
            const user = auth.currentUser;

            if (!user) {
                console.error("No se encontró un usuario autenticado.");
                return;
            }

            const userId = user.uid; // ID del usuario autenticado
            const userDocRef = doc(db, "usuarios", userId);
            const userDocSnap = await getDoc(userDocRef);

            if (!userDocSnap.exists()) {
                console.error("No se encontró el usuario en Firestore.");
                return;
            }

            const currentUser = userDocSnap.data();
            const currentUserRole = currentUser.role;

            console.log(`Rol del usuario actual: ${currentUserRole}`);

            let querySnapshot;
            if (currentUserRole === "admin") {
                // Si el rol es "admin", obtener todos los usuarios
                querySnapshot = await getDocs(collection(db, "usuarios"));
            } else if (currentUserRole === "prov") {
                // Si el rol es "prov", obtener solo los usuarios creados por este usuario
                const q = query(collection(db, "usuarios"), where("createdBy", "==", userId));
                querySnapshot = await getDocs(q);
            } else {
                console.warn("Rol desconocido, no se aplicará ningún filtro.");
                return;
            }

            // Mapear los usuarios obtenidos
            const usuariosData = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
            setUsuarios(usuariosData);

            console.log("Usuarios filtrados:", usuariosData);
        } catch (error) {
            console.error("Error al obtener los usuarios:", error);
        }
    };

    // Obtener los tipos de espacio cuando el componente se monta
    useEffect(() => {
        users();
    }, []);

    const openModalUpdate = (usuario) => {
        setModalIsOpenUpdate(true);
    };

    const closeModalUpdate = () => {
        setModalIsOpenUpdate(false);
        
    };
    // Función para abrir el modal con los datos del usuario
    const openDeleteModal = (usuario) => {
        setSelectedUsuario(usuario); // Asigna el usuario seleccionado
        setModalIsOpenDelete(true);    // Abre el modal
    };

    // Función para cerrar el modal
    const closeModalDelete = () => {
        setModalIsOpenDelete(false);
        setSelectedUsuario(null); // Limpia la selección del usuario
    };

   

    useEffect(() => {
        const fetchCompras = async () => {
            try {
                const comprasSnapshot = await getDocs(collection(db, 'comprasPendientes'));
                const comprasData = [];
    
                for (const compraDoc of comprasSnapshot.docs) {
                    const compra = compraDoc.data();
    
                    // Convertir purchaseDate a formato de fecha y hora legible
                    const formattedDate = compra.purchaseDate
                        ? new Date(compra.purchaseDate.seconds * 1000).toLocaleString('es-EC', {
                              year: 'numeric',
                              month: 'long',
                              day: 'numeric',
                              hour: 'numeric',
                              minute: 'numeric',
                              second: 'numeric',
                          })
                        : 'Fecha no disponible';
    
                    // Obtener el usuario relacionado por userId
                    const usuarioDoc = await getDoc(doc(db, 'usuarios', compra.userId));
                    if (usuarioDoc.exists()) {
                        const usuario = usuarioDoc.data();
                        comprasData.push({
                            id: compraDoc.id, // ID del documento
                            ...compra,
                            name: usuario.name,
                            lastName: usuario.lastName,
                            purchaseDate: formattedDate, // Usar la fecha formateada
                        });
                    }
                }
    
                setCompras(comprasData);
                setFilteredCompras(comprasData);
            } catch (error) {
                console.error('Error fetching compras:', error);
            }
        };
    
        fetchCompras();
    }, []);
    

    const handleSearch = (e) => {
        const value = e.target.value.toLowerCase();
        setSearch(value);

        const filtered = compras.filter((compra) =>
            compra.name.toLowerCase().includes(value) || compra.lastName.toLowerCase().includes(value)
        );

        setFilteredCompras(filtered);
    };
    const handleAceptar = async (compra) => {
        try {
            const userId = compra.userId; // ID del usuario
            const usuarioRef = doc(db, "usuarios", userId);
            
            // Obtener los datos actuales del usuario
            const usuarioDoc = await getDoc(usuarioRef);
    
            let currentCoins = 0;
            let usuarioData = {};
    
            if (usuarioDoc.exists()) {
                usuarioData = usuarioDoc.data();
                currentCoins = usuarioData.coins || 0;
            }
    
            // Obtener los datos del paquete para extraer validityTime
            const packageRef = doc(db, "coinPackages", compra.packageId);
            const packageDoc = await getDoc(packageRef);
    
            if (!packageDoc.exists()) {
                toast.error("El paquete no existe.");
                return;
            }
    
            const validityTime = packageDoc.data().validityTime || 0; // Días de vigencia
    
            // Calcular las fechas
            const fechaActual = new Date();
            const fechaExpiracion = new Date();
            fechaExpiracion.setDate(fechaExpiracion.getDate() + validityTime); // Sumar los días de vigencia
    
            // Calcular los nuevos valores de monedas
            const newCoins = currentCoins + compra.coinAmount;
    
            // Actualizar los datos del usuario en Firestore
            await updateDoc(usuarioRef, {
                coins: newCoins,
                coinsComprados: newCoins,
                coinRenovation: fechaActual, // Fecha de renovación (cuando se ejecutó la acción)
                coinExpiration: fechaExpiracion, // Fecha de expiración sumando validityTime días
            });
    
            toast.success(`Coins actualizados para ${usuarioData.name || "Usuario"}: Total Coins: ${newCoins}`);
    
            // Eliminar la compra pendiente de la colección
            await deleteDoc(doc(db, "comprasPendientes", compra.id));
            setCompras((prev) => prev.filter((c) => c.id !== compra.id));
            setFilteredCompras((prev) => prev.filter((c) => c.id !== compra.id));
    
        } catch (error) {
            console.error("Error al aceptar la compra:", error);
            toast.error("Hubo un error al aceptar la compra.");
        }
    };
    
    const handleRechazar = async (compra) => {
        try {
            // Eliminar la compra pendiente de la colección
            await deleteDoc(doc(db, "comprasPendientes", compra.id));
    
            // Actualizar la lista de compras
            setCompras((prev) => prev.filter((c) => c.id !== compra.id));
            setFilteredCompras((prev) => prev.filter((c) => c.id !== compra.id));
    
            toast.success("Compra rechazada exitosamente.");
        } catch (error) {
            console.error("Error al rechazar la compra:", error);
            toast.error("Hubo un error al rechazar la compra.");
        }
    };
    

    return (
        <div>
            <Navbar /> 
                           
<br>
</br><br/>
            <div className='center-header-type'>
                <img className='imagenlateral1' src={Lateral1} alt="Lateral" />
                <h2>Verificar Coins</h2>
                
                <img className='imagenlateral2' src={Lateral2} alt="Lateral" />
            </div>
            
           <div className="table-container-type">
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr>
                            <th className="table-header">Nombres</th>
                            <th className="table-header">Apellidos</th>
                            <th className="table-header">Coins Comprados</th>
                            <th className="table-header">Precio</th>
                            <th className="table-header">Fecha de Compra</th>
                            <th className="table-header">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredCompras.length > 0 ? (
                            filteredCompras.map((compra, index) => (
                                <tr key={index} className="table-row">
                                    <td className="table-cell">{compra.name}</td>
                                    <td className="table-cell">{compra.lastName}</td>
                                    <td className="table-cell">{compra.coinAmount}</td>
                                    <td className="table-cell">${compra.price}</td>
                                    <td className="table-cell">{compra.purchaseDate}</td>
                                    <td className="table-cell">
                                        <button onClick={() => handleAceptar(compra)}>Aceptar</button>
                                        <button onClick={() => handleRechazar(compra)}>Rechazar</button>
                                    </td>

                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="6" style={{ textAlign: 'center', padding: '20px' }}>
                                    No se encontraron registros.
                                </td>
                            </tr>
                        )}
                    </tbody>

                </table>
            </div>

            <Modal
                isOpen={modalIsOpenUpdate}
                onRequestClose={closeModalUpdate}
                contentLabel="Editar Usuario"
            >
                <h2>Aceptar</h2>
                
                <button
                    className="modal-button"
                    onClick={closeModalUpdate}
                    style={{ marginTop: "10px" }}
                >
                    Cancelar
                </button>
            </Modal>


            <Modal
                isOpen={modalIsOpenDelete}
                onRequestClose={closeModalDelete}
                contentLabel="Confirmar Eliminación"
            >
                <h2>¿Estás seguro que deseas eliminar este usuario?</h2>
                <button
                    onClick={closeModalDelete}
                    className="modal-button"
                >
                    Cancelar
                </button>
            </Modal>

        </div>

    );
};

export default VerificarCoins;
